
  var _styles = {
  "cfe-search-area": {
    "display": "flex",
    "flexDirection": "column",
    "backgroundColor": "rgb(255,255,255)"
  },
  "cfe-search-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.37333rem",
    "marginLeft": "0.32rem",
    "marginRight": "0.32rem",
    "marginBottom": "0.26667rem"
  },
  "cfe-search-input-wrap": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "flex": 1,
    "height": "0.85333rem",
    "backgroundColor": "rgb(244,245,248)",
    "borderRadius": "0.58667rem",
    "paddingLeft": "0.26667rem",
    "paddingRight": "0.26667rem"
  },
  "cfe-search-icon": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.48rem",
    "color": "rgb(153,153,153)",
    "marginRight": "0.10667rem"
  },
  "cfe-search-input": {
    "width": "7.33333rem",
    "flex": 1,
    "fontSize": "0.37333rem",
    "lineHeight": "0.48rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC"
  },
  "cfe-search-close-wrap": {
    "alignItems": "center",
    "justifyContent": "center",
    "paddingLeft": "0.13333rem",
    "height": "0.66667rem",
    "width": "0.66667rem"
  },
  "cfe-search-close": {
    "fontSize": "0.53333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(153,153,153)"
  },
  "cfe-current-city-row": {
    "display": "flex",
    "flexDirection": "column"
  },
  "cfe-current-city-text": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "marginLeft": "0.32rem",
    "marginBottom": "0.21333rem"
  },
  "cfe-current-city-divider": {
    "height": "0.01333rem",
    "backgroundColor": "rgb(244,245,248)",
    "marginLeft": "0.32rem",
    "marginRight": "0.32rem"
  },
  "cfe-suggest-list": {
    "display": "flex",
    "flexDirection": "column"
  },
  "cfe-suggest-item": {
    "display": "flex",
    "flexDirection": "column"
  },
  "cfe-suggest-text": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "marginTop": "0.32rem",
    "marginBottom": "0.32rem",
    "marginLeft": "0.32rem"
  },
  "cfe-suggest-divider": {
    "height": "0.01333rem",
    "backgroundColor": "rgb(244,245,248)"
  },
  "cfe-not-found": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "paddingTop": "1.6rem"
  },
  "cfe-not-found-text": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  